import React from "react";

import "./Header.scss";
import { NavLink, useLocation } from "react-router-dom";
import { NavHashLink as CuNavLink } from "react-router-hash-link";

const Header = () => {
  const location = useLocation();

  const isHomeActive = location.pathname === "/" && !location.hash;

  const isSpecialtyActive =
    location.pathname === "/" && location.hash === "#our-specialty";

  return (
    <div className="df acsa header">
      <div className="df acsa content_wrpr">
        <div className="logo_wrpr"></div>

        <div className="df acsa mla ffcr navs_wrpr">
          <NavLink
            to="/"
            className={() =>
              `df acsa nav_wrpr ${isHomeActive ? "selected" : ""}`
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/services"
            className={({ isActive }) =>
              `df acsa nav_wrpr ${isActive ? "selected" : ""}`
            }
          >
            Services
          </NavLink>

          <CuNavLink
            to="/#our-specialty"
            className={() =>
              `df acsa nav_wrpr ${isSpecialtyActive ? "selected" : ""}`
            }
          >
            Our Specialty
          </CuNavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              `df acsa nav_wrpr ${isActive ? "selected" : ""}`
            }
          >
            About
          </NavLink>

          <NavLink
            to="/contact-us"
            className={({ isActive }) =>
              `df acsa nav_wrpr ${isActive ? "selected" : ""}`
            }
          >
            Contact Us
          </NavLink>

          <button className="df acc ffcr call_btn">Schedule a Call</button>
        </div>
      </div>
    </div>
  );
};

export default Header;
